import React from 'react';
import styles from './BarGradient.module.scss';

const BarGradient = ({ maxWidth = 480, sx = {} }) => {
    return <div style={{ maxWidth: maxWidth, ...sx }} className={styles.bar}></div>;
};

export default BarGradient;
